import CircleIcon from "@mui/icons-material/Circle";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import HelpIcon from "@mui/icons-material/Help";
import EmailIcon from "@mui/icons-material/Email";
import React from "react";

export const menu = [
    {
        id: "1",
        icon: <SpaceDashboardIcon fontSize="small" />,
        title: "Home",
        link: "/",
        items: [],
    },
    {
        id: "2",
        title: "Browse gallery",
        icon: <ImageSearchIcon fontSize="small" />,
        link: "/favourite",
        items: [],
    },
    {
        id: "3",
        title: "How this works",
        icon: <HelpIcon fontSize="small" />,
        onClick: () => {
            window
                .open(
                    `https://app.tango.us/app/workflow/How-to-get-started-with-the-Fresh-Artists-Corporate-Art-Portal-a540880a49054a0b91a16f7082101e1f`,
                    "_blank"
                )
                .focus();
        },
        items: [],
    },
    {
        id: "4",
        title: "Contact us",
        icon: <EmailIcon fontSize="small" />,
        onClick: () => {
            window.open(`https://www.freshartists.org/contact-us`, "_blank").focus();
        },

        items: [],
    },
];
